import React, { useState, useEffect } from 'react';
import './Header.css';
import logos from "../Assets/logos.png"
import { Link, useNavigate } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate=useNavigate();


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
 const scrollDown = () => {
  window.scrollTo({
    top: 1000,
    behavior: "smooth",
  });
};
  return (
    <header className="header">
      <div className={`header-wrapper ${isScrolled ? 'scrolled' : ''}`}>
        {/* Logo */}
        <div className="logo">
          <Link to="/" className="logo-icon"> 
            <img src={logos} alt="" className="logo-s"/>
          </Link>
        </div>

        {/* Center Navigation Container with rounded blur effect */}
        <div className="nav-container">
          <nav className="nav">
            <ul className="nav-list">
              {/* Home Dropdown */}
              <li >      
                <Link to="/" className="nav-link">
                  Home
                </Link>
              </li>

              {/* Services Dropdown */}
              <li >
                <Link to="/services" className="nav-link">
                  Services
                </Link>
              </li>

              {/* Pricing */}
              <li >
                <Link to="/about" className="nav-link">About Us</Link>
              </li>

              {/* Pages Dropdown */}
              <li >
                <Link to="/team" className="nav-link">
                  Team
                </Link>
              </li>

              {/* Contacts */}
              <li className="nav-item">
                <Link to="/contact" className="nav-link">Contact Us</Link>
              </li>
            </ul>
          </nav>

        </div>

        {/* CTA Button - Outside nav container */}
        <button className="cta-btn" onClick={scrollDown}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Get Started
        </button>

        {/* Mobile Hamburger Menu */}
        <button 
          className="hamburger-btn" 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={isMobileMenuOpen ? 'active' : ''}></span>
          <span className={isMobileMenuOpen ? 'active' : ''}></span>
          <span className={isMobileMenuOpen ? 'active' : ''}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-nav-list">
          <li><Link to="/" onClick={() => {setIsMobileMenuOpen(false);navigate('/')}}>Home</Link></li>
          <li><Link to="/services" onClick={() => {setIsMobileMenuOpen(false)}}>Services</Link></li>
          <li><Link to="/about" onClick={() => {setIsMobileMenuOpen(false)}}>About</Link></li>
          <li><Link to="/team" onClick={() => {setIsMobileMenuOpen(false)}}>Team</Link></li>
          <li><Link to="/contact" onClick={() => {setIsMobileMenuOpen(false)}}>Contacts</Link></li>
        </ul>
      </div>
    </header>
  );
};

export default Header;